import { Text } from '~/shared/components/Text';
import { parseSeoFaq } from './parseSeoFaq';
import { Entry, Section, Wrapper } from './styled';

const CategorySeoFaq = ({ channelNodeSeoFaq }: { channelNodeSeoFaq?: string | null }) => {
    const sections = parseSeoFaq(channelNodeSeoFaq);

    if (!sections.length) {
        return null;
    }

    return (
        <Wrapper>
            {sections.map((section, sectionIndex) => (
                <Section key={sectionIndex}>
                    {section.title ? (
                        <Text as="h2" variant="display5">
                            {section.title}
                        </Text>
                    ) : null}

                    {section.entries.map(({ heading, text }, entryIndex) => (
                        <Entry key={entryIndex}>
                            {heading ? (
                                <Text as="h3" variant="display6">
                                    {heading}
                                </Text>
                            ) : null}
                            {text ? (
                                <Text as="p" variant="paragraph">
                                    {text}
                                </Text>
                            ) : null}
                        </Entry>
                    ))}
                </Section>
            ))}
        </Wrapper>
    );
};

export default CategorySeoFaq;
